export type ImageOpts = {
  w?: number
  h?: number
  quality?: number
  dpr?: number
}

export const imageUrl = (
  src: string | null | undefined,
  opts?: ImageOpts
): string => {
  if (!src) return ''
  const base = import.meta.env.VITE_IMAGE_PROXY_URL

  if (!base) return src
  if (src.startsWith(base)) return src

  const { w, h, quality = 80 } = opts ?? {}
  const hasResize = w !== undefined || h !== undefined
  const resize = hasResize ? `rs:fill:${w ?? 0}:${h ?? 0}/` : ''
  const dpr =
    opts?.dpr ?? Math.min(Math.ceil(globalThis.devicePixelRatio ?? 1), 3)
  const dprPart = hasResize && dpr > 1 ? `dpr:${dpr}/` : ''

  return `${base}/insecure/${resize}${dprPart}q:${quality}/plain/${encodeURIComponent(src)}@webp`
}
